import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { get, post, _delete, put } from "util/requests";
import styles from "./deviations_modal.module.css";
import { Dialog } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import RadioGroup from "ui/crfs/radio_group";
import Select from "ui/crfs/select";
import DateTime from "ui/crfs/date_time";
import Text from "ui/crfs/text";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import { arrayHaveCommonItems } from "util/helpers";
import DropMenu from "../../../../../../views/edc/components/drop_menu";
import NotificationWindow from "ui/crfs/notification_widget/components/notification_window";

export default function DeviationsModal(props) {
  const { showingModal = false, setShowingModal, subject_id, RefetchTableData, study_id } = props;

  const permissions = useSelector((state) => state.user.userData.permissions);

  const [spinning, setSpinning] = useState(false);
  const [deleteSpinning, setDeleteSpinning] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [files, setFiles] = useState([]);
  const [valueObj, setValueObj] = useState({});
  const [queryModalData, setQueryModalData] = useState(null);
  const dropMenuRef = useRef(null);
  const uploadRef = useRef(null);

  useEffect(() => {
    if (showingModal.constructor === Boolean) {
      setValueObj({});
      setFiles([]);
    } else {
      setValueObj({
        deviation_reason: { value: showingModal.deviation_reason },
        corrective_action: { value: showingModal.corrective_action },
        clinical_trial_name: { value: showingModal.clinical_trial_name },
        comments: { value: showingModal.comments },
        ethics_notified: { value: showingModal.ethics_notified },
        other_deviation_details: { value: showingModal.other_deviation_details },
        consent_id: showingModal.consent_id,
        data_from_open: true,
      });
      if (showingModal.file_name) {
        setFiles([{ name: showingModal.file_name, id: showingModal.file_id }]);
      }
    }
    setDeleteConfirm(false);
    setDeleteSpinning(false);
  }, [showingModal]);

  const handleFileChange = (e) => {
    setFiles([e.target.files[0]]);
  };

  const submit_form = (is_update = false) => {
    let data = { subject_id, is_update, deviation_id: showingModal.id || null, study_id };
    Object.entries(valueObj).forEach(([key, value]) => {
      if (value?.value) data[key] = value.value;
    });

    post("/deviation", data).then(() => {
      // setShowingModal(false);
      // setSpinning(false);
      // RefetchTableData();

      if (showingModal.flags?.includes("all_monitored") || showingModal.flags?.includes("all_qa")) {
        let _flags = showingModal.flags.filter((f) => f !== "all_monitored" && f !== "all_qa");
        if (showingModal.flags.includes("all_monitored")) {
          _flags.push("remonitored");
        }
        if (showingModal.flags.includes("all_qa")) {
          _flags.push("reqa");
        }

        post(`/deviation_flags_update/${showingModal.id}`, { subject_id, flags: _flags }).then(() => {
          setShowingModal(false);
          setSpinning(false);
          RefetchTableData();
        });
      } else {
        setShowingModal(false);
        setSpinning(false);
        RefetchTableData();
      }
    });
  };

  const updateDeviationFlags = (flag, is_add = true) => {
    //flag coming in will be all_xxxx
    return new Promise((resolve) => {
      let flags = showingModal.flags || [];
      flags = flags.filter(
        (f) => f !== flag && f !== flag.replace("all_", "") && f !== `re${flag.replace("all_", "")}`
      );
      if (is_add) {
        flags.push(flag);
      }
      setShowingModal({ ...showingModal, flags });
      post(`/deviation_flags_update/${showingModal.id}`, { subject_id, flags }).then(() => {
        RefetchTableData();
        resolve();
      });
    });
  };

  const deactivate_form = () => {
    setDeleteSpinning(true);
    _delete(`/deviation/${subject_id}/${showingModal.id}?study_id=${study_id}`).then(() => {
      setDeleteSpinning(false);
      setShowingModal(false);
      RefetchTableData();
    });
  };

  const activate_form = () => {
    setDeleteSpinning(true);
    put(`/deviation/${subject_id}/${showingModal.id}?study_id=${study_id}`).then(() => {
      setDeleteSpinning(false);
      setShowingModal(false);
      RefetchTableData();
    });
  };

  const openFile = (id, name) => {
    get(`/presigned_url/${id}`).then((ret) => {
      if (ret.data?.url) {
        window.open(ret.data.url, "_blank");
      }
    });
  };

  const title = showingModal.constructor === Boolean ? "Add Protocol Deviation" : "Protocol Deviation Details";

  const submitDisabled = !(
    valueObj.deviation_reason?.value &&
    ((valueObj.deviation_reason?.value === "enrolled_other_trial" &&
      valueObj.clinical_trial_name?.value &&
      valueObj.comments?.value) ||
      (valueObj.deviation_reason?.value === "other" && valueObj.other_deviation_details?.value)) &&
    valueObj.corrective_action?.value &&
    valueObj.ethics_notified?.value
  );
  const read_only = !permissions.includes("create_edit_deviation_record");

  const is_update = showingModal.constructor === Object;

  return (
    <Dialog open={showingModal} onClose={() => setShowingModal(false)} maxWidth={800}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{title}</div>
        {showingModal.constructor !== Boolean ? (
          <div className={styles.drop_menu_wrapper}>
            <DropMenu
              is_deviation_form
              crf_status={"test"}
              crf_sign_status={"test"}
              crfFlags={showingModal.flags}
              updateNonCrfFlags={updateDeviationFlags}
              setQueryModalData={setQueryModalData}
              data={showingModal}
            />
          </div>
        ) : null}
        <input ref={uploadRef} type="file" onChange={handleFileChange} style={{ display: "none" }} />

        <div style={{ width: "100%" }}>
          <RadioGroup
            field={{
              value_obj: valueObj.deviation_reason || {},
            }}
            options={[
              { value: "enrolled_other_trial", label: "Subject enrolled into anther clinical trial" },
              { value: "other", label: "Other Protocol Deviation" },
            ]}
            title={"Primary Reason for Deviation"}
            orientation={"vertical"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.deviation_reason = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        {valueObj.deviation_reason?.value === "enrolled_other_trial" ? (
          <React.Fragment>
            <div style={{ width: "100%" }}>
              <Text
                field={{
                  value_obj: valueObj.clinical_trial_name || {},
                }}
                title={"Please specify the name of the clinical trial"}
                onUpdate={(value_obj) => {
                  let data = { ...valueObj };
                  data.clinical_trial_name = value_obj;
                  setValueObj(data);
                }}
                read_only={read_only}
                hideElementMenu
              />
            </div>
            <div style={{ width: "100%" }}>
              <Text
                field={{
                  value_obj: valueObj.comments || {},
                  multiline: true,
                }}
                title={"Comments"}
                onUpdate={(value_obj) => {
                  let data = { ...valueObj };
                  data.comments = value_obj;
                  setValueObj(data);
                }}
                read_only={read_only}
                hideElementMenu
              />
            </div>
          </React.Fragment>
        ) : null}
        {valueObj.deviation_reason?.value === "other" ? (
          <div style={{ width: "100%" }}>
            <Text
              field={{
                value_obj: valueObj.other_deviation_details || {},
              }}
              title={"Please specify"}
              onUpdate={(value_obj) => {
                let data = { ...valueObj };
                data.other_deviation_details = value_obj;
                setValueObj(data);
              }}
              read_only={read_only}
              hideElementMenu
            />
          </div>
        ) : null}
        <div style={{ width: "100%" }}>
          <RadioGroup
            field={{
              value_obj: valueObj.corrective_action || {},
            }}
            options={[
              { value: "none", label: "None" },
              { value: "retraining", label: "Retraining" },
              { value: "other", label: "Other" },
            ]}
            title={"Corrective Action Performed"}
            orientation={"vertical"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.corrective_action = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <RadioGroup
            field={{
              value_obj: valueObj.ethics_notified || {},
            }}
            options={[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ]}
            title={"Ethics Committee Notified"}
            orientation={"vertical"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.ethics_notified = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div className={styles.modal_button_wrapper}>
          {showingModal.constructor !== Boolean && !deleteConfirm && permissions.includes("admin_deviation") ? (
            <LoadingButton
              disabled={false}
              variant="contained"
              loading={false}
              onClick={showingModal.status === "inactive" ? activate_form : deactivate_form}
              color="inherit"
              sx={{ color: "#555" }}
            >
              {showingModal.status === "inactive" ? "Activate" : "Deactivate"}
            </LoadingButton>
          ) : null}

          {permissions.includes("create_edit_deviation_record") ? (
            <React.Fragment>
              {is_update ? (
                <LoadingButton
                  disabled={false}
                  variant="contained"
                  loading={spinning}
                  onClick={() => {
                    setSpinning(true);
                    submit_form(true);
                  }}
                >
                  Update
                </LoadingButton>
              ) : (
                <LoadingButton
                  disabled={submitDisabled}
                  variant="contained"
                  loading={spinning}
                  onClick={() => {
                    setSpinning(true);
                    submit_form();
                  }}
                >
                  Submit
                </LoadingButton>
              )}
            </React.Fragment>
          ) : null}

          <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
            Close
          </LoadingButton>
        </div>
      </div>
      <NotificationWindow
        crf_name={"Manual Deviation"}
        data_name={null}
        showing={queryModalData?.showing}
        closeNotificationWindow={() => setQueryModalData(null)}
        query={queryModalData || {}}
        crf_id={"manual_deviation"}
        field_id={null}
        subject_id={subject_id}
        visit_index={1}
        setQuery={(crf_id, field_id, query) => {
          setShowingModal({ ...showingModal, query });
          RefetchTableData();
        }}
        calcUpdateToCrfStatus={() => {}}
        currentValueDisplay={""}
        multi_entry_crf_id={showingModal?.id}
        form_type={"multi_entry"}
        crf_slug={queryModalData?.slug}
      />
    </Dialog>
  );
}
